export default {
  data() {
    return {
      cashTurn: null,
    }
  },
  mounted() {
    this.cashTurn = this.$store.getters.turn;
  },
  watch: {
    '$store.getters.turn'(val) {
      if (val) {
        this.cashTurn = this.$store.getters.turn;
      }
    },
    cashTurn(val) {
      this.search();
    }
  },
  methods: {
    querySelections(params, paginate, order) {
      return new Promise((resolve, reject) => {

        //localStorage.setItem('filters_module',
        //  JSON.stringify({ url: this.$route.fullPath, params, '_paginate': paginate, '_order': order }));
        this.$store.dispatch('addFilter', { path: this.title, values: { url: this.$route.fullPath, params, '_paginate': paginate, '_order': order } });
        const paramsDefault = this.getParamsDefault(params);
        if (this.cashTurn) {
          const paramsCashRegister = {
            cash_register: this.cashTurn.bill_cash_register_id,
            cash_register_turn: this.cashTurn.id
          }
          this.$http.get(this.url, { ...params, ...paramsDefault, ...paramsCashRegister, '_paginate': paginate, '_order': order }, false)
            .then(res => {
              let { total, items, module_actions } = res
              total = parseInt(total);
              resolve({ items, total, module_actions });
            }).catch(err => {
              reject(err);
            }).finally(() => (this.loading = false));
        } else {
          this.loading = false;
          resolve({ items: [], total: 0, module_actions: [] });
        }
      });
    },
  }
}
